var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "feitian" } },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24, offset: 12 } }, [
            _c("p", [_vm._v("这是飞天学习器")]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 6, offset: 6 } }, [
            _c("span", [_vm._v("今天是：")]),
            _c("span", [_vm._v(_vm._s(_vm.today))]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 6, offset: 6 } }, [
            _c("p", [_vm._v("今天已经完成了这些作业")]),
            _vm._v(" "),
            _c("div", [_vm._v("\n        作业列表，待补充\n      ")]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 18, offset: 6 } }, [
            _c("div", { attrs: { id: "labelTitle" } }, [
              _vm._v("愉快的开始今天的作业吧"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c("span", [_vm._v("作业标题：")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.curTitle,
                            callback: function ($$v) {
                              _vm.curTitle = $$v
                            },
                            expression: "curTitle",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c("span", [_vm._v("课目：")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "点击选择" },
                            model: {
                              value: _vm.curClass,
                              callback: function ($$v) {
                                _vm.curClass = $$v
                              },
                              expression: "curClass",
                            },
                          },
                          _vm._l(_vm.classes_list, function (item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-row", [
                  _vm.curStateLabel === "start"
                    ? _c(
                        "div",
                        { attrs: { id: "ui-start" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.dutyStart },
                                },
                                [_vm._v("开始学习")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curStateLabel === "doing"
                    ? _c(
                        "div",
                        { attrs: { id: "ui-doing" } },
                        [
                          _c("div", { staticClass: "timeInterval" }, [
                            _vm._v(_vm._s(_vm.curTimeStr)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.dutyPause },
                            },
                            [_vm._v("暂停一会")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.dutyStop },
                            },
                            [_vm._v("结束")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curStateLabel === "pause"
                    ? _c(
                        "div",
                        { attrs: { id: "ui-pause" } },
                        [
                          _c("div", { staticClass: "timeInterval" }, [
                            _vm._v(_vm._s(_vm.curTimeStr)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.dutyRestart },
                            },
                            [_vm._v("重新开始")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curStateLabel === "stop"
                    ? _c(
                        "div",
                        { attrs: { id: "ui-stop" } },
                        [
                          _c("div", { staticClass: "timeInterval" }, [
                            _vm._v(_vm._s(_vm.curTimeStr)),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "完成了 " +
                                _vm._s(_vm.curClass) +
                                " 的 " +
                                _vm._s(_vm.curTitle) +
                                "，"
                            ),
                            _c("span", { staticClass: "timeUsage" }, [
                              _vm._v(
                                "用时 " +
                                  _vm._s(_vm.curMin) +
                                  " 分钟 " +
                                  _vm._s(_vm.curSec) +
                                  " 秒"
                              ),
                            ]),
                            _vm._v("， "),
                            _c("span", { staticClass: "bigTitle" }, [
                              _vm._v("好棒"),
                            ]),
                            _vm._v("!"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.dutyNew },
                            },
                            [_vm._v("开始一项新的作业吧")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("el-alert", { attrs: { type: "warning" } }, [
                        _vm._v(_vm._s(_vm.alertData)),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 18, offset: 6 } }, [
            _c("p", [_vm._v("Version: 1.1.0 ")]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }